// extracted by mini-css-extract-plugin
export default {"wrapper":"PageCrash_wrapper__CKfLJ","illustration":"PageCrash_illustration__UZqik"};